import Vue from 'vue'
import VueRouter from 'vue-router'
import fuwu from '../views/fuwu.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'fuwu',
    component: fuwu
  },
  {
    path: '/ys',
    name: 'ys',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ys.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
